import React, { useState, useEffect } from 'react';
import './PopUp.scss';
import { navigate } from 'gatsby';
import Modal from '../Modal/modal';
import toast from '../../../common/components/Toast/Toast';
import { FailureSvg, SuccessDes, LoadingDes } from './CommonSvgs';

const PopUp = props => {
  switch (props.type) {
    case 'default':
    default:
      return success(
        props.text,
        props.type,
        props.dontClose,
        props.autoClose,
        props.show,
        props.setShow,
        props.goto,
        props.gotoLink,
        props.gotoText
      );
    case 'success':
      return success(
        props.text,
        props.type,
        props.dontClose,
        props.autoClose,
        props.show,
        props.setShow,
        props.goto,
        props.gotoLink,
        props.gotoText
      );
    case 'fail':
      return fail(
        props.text,
        props.type,
        props.dontClose,
        props.autoClose,
        props.show,
        props.setShow,
        props.goto,
        props.gotoLink,
        props.gotoText
      );
    case 'loading':
      return loading(
        props.text,
        props.iconType,
        props.type,
        props.dontClose,
        props.autoClose,
        props.show,
        props.setShow,
        props.goto,
        props.gotoLink,
        props.gotoText
      );
  }
};

const ModalWithAnim = (
  text,
  icon,
  type,
  dontClose = false,
  autoClose = false,
  show = false,
  setShow,
  goto = false,
  gotoLink = '/app/dashboard',
  gotoText = 'Go To DashBoard'
) => {
  return (
    <React.Fragment>
      <Modal
        show={show}
        type={type}
        setShow={setShow}
        noCloseBtn={false}
        dontClose={dontClose}
        autoClose={autoClose}
      >
        <div className="flex flex-col justfy-center items-center content-center text-center text-black-500">
          {icon}
          <div className="w-full mt-2 mb-4 text-sm">{text}</div>
          {goto ? (
            <div className="w-full mt-1 mb-4">
              <button
                className="submitButton"
                onClick={() => {
                  navigate(gotoLink);
                }}
              >
                {gotoText}
              </button>
            </div>
          ) : null}
        </div>
      </Modal>
    </React.Fragment>
  );
};

const success = (
  text,
  type,
  dontClose,
  autoClose,
  show,
  setShow,
  goto,
  gotLink,
  gotText
) => {
  let successDes = <SuccessDes />;

  return ModalWithAnim(
    text,
    successDes,
    type,
    dontClose,
    autoClose,
    show,
    setShow,
    goto,
    gotLink,
    gotText
  );
};
const fail = (
  text,
  type,
  dontClose,
  autoClose,
  show,
  setShow,
  goto,
  gotLink,
  gotText
) => {
  let failureDes = <FailureSvg />;

  return ModalWithAnim(
    text,
    failureDes,
    type,
    dontClose,
    autoClose,
    show,
    setShow,
    goto,
    gotLink,
    gotText
  );
};
const loading = (
  text,
  iconType,
  type,
  dontClose,
  autoClose,
  show,
  setShow,
  goto,
  gotLink,
  gotText
) => {
  let loadingDes;
  if (iconType == 'circle') {
    loadingDes = (
      <div className="loader">
        <div className="loader__figure"></div>
      </div>
    );
  } else {
    loadingDes = <LoadingDes />;
  }
  return ModalWithAnim(
    text,
    loadingDes,
    type,
    dontClose,
    autoClose,
    show,
    setShow,
    goto,
    gotLink,
    gotText
  );
};
export default React.memo(PopUp);
